// Shared case-picker label — the CaseDetail convention: "case_name (display_number)".
// display_number is the client-qualified identifier ("23-030-Minton"), so bare
// titles like "QDRO" always render with their client. Falls back gracefully for
// payloads without display_number.
export const caseLabel = (c) => {
  if (!c) return '';
  const name = c.case_name || c.name || String(c.case_number || '');
  return c.display_number && !name.includes(c.display_number)
    ? `${name} (${c.display_number})`
    : name;
};

export default caseLabel;
